import { appSelectors } from '@appStore/reducers/app'
import clsx from 'clsx'
import { useDateHandlers } from 'components/molecules/dateSelection/hooks'
import {
	DateSelection,
	DAYS,
	getInitials,
	isWeekDay,
	transformToWorkingHours,
	useHasSelected
} from 'components/molecules/dateSelection/index.js'
// components
import { AuthTemplate } from 'components/templates/authTemplate'
import { CONSTS } from 'config/objectConst.js'
import { workspaceApi } from 'features/workspace'
import { useMemo, useState } from 'react'
import { useAppSelector } from 'shared/hooks/store.ts'
import { typo } from 'shared/styles'
import { LoadingButton } from 'shared/ui'

import { AccountInUseModal } from './Modal'
import css from './NoWorkingHours.module.scss'

const LEAD = `You can work up to ${CONSTS.WORKING_HOURS} hours a day.`

const getStarted = () => getInitials(isWeekDay)

const cn = AuthTemplate.cn

export function NoWorkingHours() {
	const [mutation, { isLoading }] = workspaceApi.useSetWorkingHoursMutation()
	const timeZone = useTimeZone()

	const [open, setOpen] = useState(false)
	const [hours, setHours] = useState(getStarted)

	async function saveWorkingHours() {
		const { isValid, oneOrMoreSelected, workspaceHours } =
			transformToWorkingHours(hours)

		setHours({ ...hours })

		if (!(isValid && oneOrMoreSelected)) {
			return
		}

		const { data } = await mutation(workspaceHours)
		if (data !== undefined) {
			setOpen(true)
		}
	}

	const hasSelected = useHasSelected(hours)
	const { handleHoursChange, toggleDay } = useDateHandlers(setHours)

	return (
		<AuthTemplate active={5}>
			<h1 className={cn.title}>Working hours</h1>
			<p className={cn.text}>{timeZone}</p>

			<small className={clsx(css.note, typo.caption)}>{LEAD}</small>
			<div className={css.wrapper}>
				{DAYS.map(day => (
					<DateSelection
						className={css.item}
						dateSelectionHandler={toggleDay}
						dayOfWeek={day}
						handleDateChange={handleHoursChange}
						hours={hours[day]}
						key={day}
					/>
				))}

				<LoadingButton
					className={clsx(css.submit, !isLoading && css.arrow)}
					disabled={!hasSelected}
					isLoading={isLoading}
					onClick={saveWorkingHours}
					type='button'
				>
					Accept
				</LoadingButton>
			</div>
			<AccountInUseModal open={open} setOpen={setOpen} />
		</AuthTemplate>
	)
}

function useTimeZone() {
	const profileTZ = useAppSelector(appSelectors.timezoneOffset)

	return useMemo(() => {
		if (profileTZ) {
			const asString = profileTZ.toString()

			const found = CONSTS.TIME_ZONES.find(item => item.value === asString)

			return found?.label ?? 0
		}

		return 0
	}, [profileTZ])
}
